import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Col,
} from "reactstrap";
import { css } from "react-emotion";
import { Formik } from "formik";
import swal from "sweetalert2";
import { handleError } from "@/util/errorHandler";
import permissions from "@/api/permissions";

const modalStyles = css`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  overflow: visible;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  width: 35rem;

  .buttons {
    display: flex;
    justify-content: space-between;
    margin: 15px 0 0;
  }
`;

const overlayStyles = css`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 1021; /* above navs, below sweetalert */
`;

class UpdatePermissionModal extends React.Component {
  state = {
    permissionName: "",
  };

  baseState = {
    ...this.state,
  };

  validateFormik = ({ permissionName }) => {
    const errors = {};

    if (permissionName.length === 0) {
      errors.roleName = "Permission name is required";
    }

    return errors;
  };

  reset = () => {
    this.setState(this.baseState);
  };

  beforeClose = () => {
    this.reset();
    this.props.onModalClose();
  };

  onSendUpdatePermissionRequest = async ({ permissionName }) => {
    try {
      const data = await permissions.createPermission(permissionName);

      await swal(
        "Success!",
        `Permission ${permissionName} successfully created.`,
        "success",
      );
      this.beforeClose();
    } catch (err) {
      handleError(err);
    }
  };

  render() {
    const form = (
      <Formik
        initialValues={{
          permissionName: this.state.permissionName,
        }}
        validate={this.validateFormik}
        onChange={this.validateFormik}
        onSubmit={this.onSendUpdatePermissionRequest}>
        {({
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          errors,
          setErrors,
        }) => (
          <Form onSubmit={handleSubmit}>
            <CardBody>
              <FormGroup row>
                <Label sm={3}>Permission name</Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="permissionName"
                    placeholder="Enter permission name"
                    invalid={Boolean(errors.permissionName)}
                    value={values.permissionName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.permissionName && (
                    <FormFeedback className="text-alert">
                      {errors.permissionName}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
            </CardBody>
            <CardFooter>
              <div className="buttons">
                <Button color="primary" type="submit">
                  <span>Create permission</span>
                </Button>
              </div>
            </CardFooter>
          </Form>
        )}
      </Formik>
    );

    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.beforeClose}
        className={modalStyles}
        overlayClassName={overlayStyles}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}>
        <Card>
          <CardHeader>
            <Button close onClick={this.beforeClose} />

            <span>Create permission</span>
          </CardHeader>
          {form}
        </Card>
      </Modal>
    );
  }
}

UpdatePermissionModal.defaultProps = {
  isOpen: false,
  onModalClose: () => {},
};

UpdatePermissionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
};

export default UpdatePermissionModal;
